import './styles.css';

const About = () => {

    return (
        <div className="about">
            <p className="about-content">
                I am a full stack developer with a passion for building web applications. I have a strong background in
                front-end development and have worked with a wide range of technologies. I am currently working on a
                project that will allow users to create and share their own personalised travel itineraries.

                This project is built using React, Node, Express, MongoDB, and a variety of other technologies.
            </p>
        </div>
    )
}

export default About;